module.exports = __webpack_public_path__ + "static/media/circle_bg.77e34c63.svg";